export const ROUTE_DEFAULT = '/';
export const ROUTE_DEFAULT_ALTERNATE = '/start';
export const ROUTE_LOGIN = '/login';
export const ROUTE_AUTH0_CALLBACK = '/auth0-callback';

export const ROUTE_PATH_SELECTION = '/select-path';

//onboarding
export const ROUTE_INTRO = '/intro';
export const ROUTE_ONBOARDING_DNA = '/onboarding-dna';
export const ROUTE_ONBOARDING_DNA_INSTRUCTIONS = '/onboarding-dna-instructions';
export const ROUTE_ONBOARDING_GENERAL = '/onboarding-general';
export const ROUTE_ONBOARDING_INTRO = '/onboarding-intro';
export const ROUTE_ONBOARDING_ENVIRONMENT = '/onboarding-environment';
export const ROUTE_ONBOARDING_LIFESTYLE = '/onboarding-lifestyle';
export const ROUTE_ONBOARDING_DISEASES = '/onboarding-diseases';
export const ROUTE_ONBOARDING_END = '/onboarding-end';

//reports
export const ROUTE_ASSESSMENT_HOME = '/assessment-home';
export const ROUTE_ASSESSMENT_DNA_RISKS = '/dna-assessment';
export const ROUTE_ASSESSMENT_ENTERPRISE_DEMO = '/enterprise-demo';
export const ROUTE_ASSESSMENT_DNA_TRAIT_GROUP = '/trait-group';
export const ROUTE_ASSESSMENT_DNA_TRAIT_DETAILS = '/trait-details';
export const ROUTE_ASSESSMENT_HEALTH_RISKS = '/comorbidities-overview';
export const ROUTE_ASSESSMENT_HEALTH_RISKS_GROUPS = '/vulnerability-assessment';
export const ROUTE_ASSESSMENT_HEALTH_RISKS_DETAILS =
  '/vulnerability-assessment-details';
export const ROUTE_ASSESSMENT_RECOMMENDATIONS = '/recommendations';
export const ROUTE_ASSESSMENT_TERMS_OF_SERVICE = '/terms-of-service';
export const ROUTE_ASSESSMENT_RESEARCH = '/research';
export const ROUTE_ASSESSMENT_SHARE_APP = '/share-app';
export const ROUTE_ASSESSMENT_FAQ = '/faq';
export const ROUTE_LANDING_PAGE = '/newuser';
export const ROUTE_ACCOUNT_VERIFIED = '/account/verified';
export const ROUTE_HEALTH_PROFILE = '/health-profile';
export const ROUTE_ASSESSMENT_LIKELIHOOD = '/likelihood-history';

//onboarding PCE
export const ROUTE_PCE_ONBOARDING_INTRO = '/pce-intro';
export const ROUTE_PCE_ONBOARDING_DNA = '/pce-onboarding-dna';
export const ROUTE_PCE_ONBOARDING_GENERAL = '/pce-onboarding-general';
export const ROUTE_PCE_ONBOARDING_SKINCARE = '/pce-onboarding-skincare';

//PCE retail experience
export const ROUTE_RETAIL_EXPERIENCE_CART = '/retail-experience-cart';
export const ROUTE_BENEFITS = '/benefits';

//for testing
export const ROUTE_RESET_USER_DATA = '/reset-user-data';
export const ROUTE_SENTRY_DUMMY_TEST = '/dummy-sentry-test';
